import axios from 'axios';
import { onUnauthorized } from './session';
import internalApi from '../utilities/internalApi';
import backofficeApi from '../utilities/backofficeApi';
import userApi from '../utilities/userApi';

function surRefus(error: any) {
  if (error.response?.status === 401 || error.response?.status === 403) {
    onUnauthorized();
  }
  return Promise.reject(error);
}

axios.interceptors.response.use(response => response, surRefus);

/* Les clients créés par axios.create (admin-service, backoffice-service,
   user-service) n'héritent pas de l'intercepteur global : leurs 401/403
   passaient inaperçus (Z1-6). location-service a déjà le sien. */
[internalApi, backofficeApi, userApi].forEach(client =>
  client.interceptors.response.use(response => response, surRefus));

/* ── fetch() brut ──────────────────────────────────────────────────────────
   Le back-office compte une trentaine d'appels en fetch() direct, dont 25 vers
   location-service, qui ne passent par aucun intercepteur axios. Tant que
   l'interceptor de location-service échouait en mode ouvert, ces appels ne
   voyaient jamais de 401. Après la refermeture ils en verront, et la plupart
   des appelants ne testent pas res.ok : l'écran resterait vide, sans message
   ni redirection. On traite donc le 401 une fois ici plutôt que sur chaque
   site d'appel.

   Restreint aux hôtes Tribe et aux URL relatives (proxy de développement)
   pour ne pas réagir au 401 d'un tiers. La réponse est renvoyée intacte :
   les appelants qui testent res.ok gardent leur comportement. */
const fetchOriginal = window.fetch.bind(window);

function versTribe(input: RequestInfo | URL): boolean {
  const url =
    typeof input === 'string' ? input :
    input instanceof URL      ? input.href :
    (input as Request).url;
  if (!url) return false;
  if (!/^https?:\/\//i.test(url)) return true;
  try {
    return new URL(url).hostname.endsWith('.tribe.sn');
  } catch {
    return false;
  }
}

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const response = await fetchOriginal(input as RequestInfo, init);
  if ((response.status === 401 || response.status === 403) && versTribe(input)) {
    onUnauthorized();
  }
  return response;
};

export default axios;
